export default function CategoryStrip() {
  const categories = [
    { label: 'Medicamentos', icon: 'ri-capsule-line' },
    { label: 'Vitaminas', icon: 'ri-plant-line' },
    { label: 'Cuidado personal', icon: 'ri-heart-pulse-line' },
    { label: 'Productos infantiles', icon: 'ri-parent-line' },
    { label: 'Primeros auxilios', icon: 'ri-first-aid-kit-line' },
  ];

  return (
    <div className="border-y border-md-sky bg-white">
      <div className="mx-auto flex max-w-[1280px] items-center gap-4 overflow-x-auto px-6 py-5 md:gap-6 md:px-12 md:py-6">
        {categories.map((cat) => (
          <span
            key={cat.label}
            className="inline-flex flex-shrink-0 items-center gap-2 rounded-full border border-md-sky bg-md-light px-4 py-2 text-[14px] font-medium text-md-ink transition-colors hover:border-md-teal/30 hover:bg-md-teal/5"
          >
            <span className="flex h-5 w-5 items-center justify-center text-md-teal">
              <i className={cat.icon} />
            </span>
            {cat.label}
          </span>
        ))}
      </div>
    </div>
  );
}